export default function ProjectInfoTile({ title, description }) {
  return (
    <div className="smallProjectInfoTileContainerInner">
      <div className="smallProjectInfoTile">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
}
